import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import withSideEffect from 'react-side-effect';
import uniq from 'lodash/uniq';
import PropTypes from 'prop-types';
var reducePropsToState = function reducePropsToState(propsList) {
  return uniq(propsList.map(function (props) {
    return props.className;
  })).join(' ');
};
function makeClassNameRenderer(tag) {
  var handleStateChangeOnClient = function handleStateChangeOnClient(stringClassNames) {
    document.getElementsByTagName(tag)[0].className = stringClassNames;
  };
  var TagNameRenderer = /*#__PURE__*/function (_React$Component) {
    function TagNameRenderer() {
      _classCallCheck(this, TagNameRenderer);
      return _callSuper(this, TagNameRenderer, arguments);
    }
    _inherits(TagNameRenderer, _React$Component);
    return _createClass(TagNameRenderer, [{
      key: "render",
      value: function render() {
        if (this.props.children) {
          return React.Children.only(this.props.children);
        }
        return null;
      }
    }]);
  }(React.Component);
  TagNameRenderer.displayName = "".concat(tag.toUpperCase(), "ClassName");
  TagNameRenderer.propTypes = {
    children: PropTypes.any
  };
  return withSideEffect(reducePropsToState, handleStateChangeOnClient)(TagNameRenderer);
}
export var BodyClass = makeClassNameRenderer('body');
export var HtmlClass = makeClassNameRenderer('html');
//# sourceMappingURL=index.js.map
